import api from "./api";

const CIDADES_CACHE_KEY = "7geracoes:cidades-ativas";
const CIDADE_UPDATE_KEY = "7geracoes:cidade-atualizada";
export const CIDADE_UPDATED_EVENT = "7geracoes:cidade-atualizada";

function publishCidadeUpdate(cidade) {
  if (!cidade || typeof window === "undefined") return;

  const detail = {
    cidade,
    slug: cidade.slug,
    updatedAt: Date.now(),
  };

  window.dispatchEvent(
    new CustomEvent(CIDADE_UPDATED_EVENT, { detail }),
  );

  try {
    localStorage.setItem(CIDADE_UPDATE_KEY, JSON.stringify(detail));
  } catch {
    // A atualização em memória continua funcionando quando o storage está indisponível.
  }
}

export function subscribeCidadeUpdates(callback) {
  if (typeof window === "undefined") return () => undefined;

  const handleLocalUpdate = (event) => callback(event.detail);
  const handleStorageUpdate = (event) => {
    if (event.key !== CIDADE_UPDATE_KEY || !event.newValue) return;

    try {
      callback(JSON.parse(event.newValue));
    } catch {
      // Ignora somente notificações de storage inválidas.
    }
  };

  window.addEventListener(CIDADE_UPDATED_EVENT, handleLocalUpdate);
  window.addEventListener("storage", handleStorageUpdate);

  return () => {
    window.removeEventListener(CIDADE_UPDATED_EVENT, handleLocalUpdate);
    window.removeEventListener("storage", handleStorageUpdate);
  };
}

export const CIDADES_ATIVAS_FALLBACK = [
  {
    _id: "fallback-lavras",
    name: "Lavras",
    city: "Lavras",
    slug: "lavras",
    active: true,
  },
  {
    _id: "fallback-macaia",
    name: "Macaia",
    city: "Macaia",
    slug: "macaia",
    active: true,
  },
  {
    _id: "fallback-sabara",
    name: "Sabará",
    city: "Sabará",
    slug: "sabara",
    active: true,
  },
  {
    _id: "fallback-sarzedo",
    name: "Sarzedo",
    city: "Sarzedo",
    slug: "sarzedo",
    active: true,
  },
  {
    _id: "fallback-varginha",
    name: "Varginha",
    city: "Varginha",
    slug: "varginha",
    active: true,
  },
];

export function getCidadesAtivasIniciais() {
  try {
    const cidadesCacheadas = JSON.parse(localStorage.getItem(CIDADES_CACHE_KEY));

    if (Array.isArray(cidadesCacheadas) && cidadesCacheadas.length > 0) {
      return cidadesCacheadas;
    }
  } catch {
    return CIDADES_ATIVAS_FALLBACK;
  }

  return CIDADES_ATIVAS_FALLBACK;
}

export function listCidadesAtivas() {
  return api
    .get("/regional-hubs", { timeout: 8000 })
    .then((res) => {
      const cidades = Array.isArray(res.data) ? res.data : [];

      try {
        localStorage.setItem(CIDADES_CACHE_KEY, JSON.stringify(cidades));
      } catch {
        return cidades;
      }

      return cidades;
    })
    .catch(() => getCidadesAtivasIniciais());
}

export function getCidadePorSlug(slug) {
  return api.get(`/regional-hubs/${slug}`).then((res) => res.data);
}

export function listCidadesAdmin() {
  return api
    .get("/regional-hubs/admin/all")
    .then((res) => {
      const cidades = Array.isArray(res.data) ? res.data : [];
      return cidades.length > 0
        ? cidades
        : CIDADES_ATIVAS_FALLBACK.map((cidade) => ({
            ...cidade,
            _isFallback: true,
          }));
    })
    .catch(() =>
      CIDADES_ATIVAS_FALLBACK.map((cidade) => ({
        ...cidade,
        _isFallback: true,
      })),
    );
}

export function getCidadeAdmin(id) {
  return api.get(`/regional-hubs/admin/${id}`).then((res) => res.data);
}

export function criarCidade(payload) {
  return api.post("/regional-hubs", payload).then((res) => {
    publishCidadeUpdate(res.data);
    return res.data;
  });
}

export function atualizarCidade(id, payload) {
  return api.put(`/regional-hubs/${id}`, payload).then((res) => {
    publishCidadeUpdate(res.data);
    return res.data;
  });
}

export function excluirCidade(id) {
  return api
    .delete(`/regional-hubs/${id}`, { data: { confirm: true } })
    .then((res) => res.data);
}

export function enviarImagemCidade(file) {
  const formData = new FormData();
  formData.append("image", file);

  return api
    .post("/media/upload", formData)
    .then((response) => response.data);
}
